import { LangLocale } from '@myre/common-i18n';

import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'localeRegion',
  standalone: true,
})
export class LocaleRegionPipe implements PipeTransform {
  public transform(lang: LangLocale): string {
    const langToDisplay = lang.includes('_') ? lang.split('_')[1] : lang;

    return langToDisplay.toUpperCase();
  }
}
